"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE = '__NATIVE_FILE__';
exports.URL = '__NATIVE_URL__';
exports.TEXT = '__NATIVE_TEXT__';